import React, { useState } from "react";
import { ChevronDown, ChevronRight, Download, Workflow } from "lucide-react";

const PDF = "/docs/SitePro_Defects_Process_Flowchart.pdf";
const PAGES = [
  ["0-overview", "Overview"],
  ["1-setup", "A · Set up"],
  ["2-recording", "B · Record defects"],
  ["3-walkthrough", "C · Client walkthrough"],
  ["4-contractor", "D · Fix & close out"],
  ["5-signoff", "E · Client sign-off"],
];

export const DefectsFlowchart = () => {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [slug, label] = PAGES[page];
  return (
    <div className="border border-amber-200 rounded-xl overflow-hidden bg-white" data-testid="defects-flowchart-section">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-amber-50/50" data-testid="defects-flowchart-toggle">
        <span className="flex items-center gap-2 font-semibold text-slate-800">
          <Workflow className="w-4 h-4 text-amber-600" />Process Flowchart — Defects &amp; Client Walkthrough
        </span>
        {open ? <ChevronDown className="w-5 h-5 text-slate-400" /> : <ChevronRight className="w-5 h-5 text-slate-400" />}
      </button>
      {open && (
        <div className="px-4 pb-5 pt-1 space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-sm text-slate-700">Step-by-step training guide for new site managers. Pick a stage, or download the printable PDF.</p>
            <a href={PDF} download className="inline-flex items-center rounded-md bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium px-3 py-2" data-testid="defects-flowchart-download">
              <Download className="w-4 h-4 mr-2" />Download PDF
            </a>
          </div>
          <div className="flex flex-wrap gap-2" role="tablist">
            {PAGES.map(([s, l], i) => (
              <button key={s} role="tab" aria-selected={i === page} onClick={() => setPage(i)}
                className={`rounded-full px-3 py-1.5 text-xs font-semibold border transition-colors ${i === page ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300 hover:border-amber-400"}`}
                data-testid={`defects-flowchart-tab-${s}`}>{l}</button>
            ))}
          </div>
          <img src={`/docs/flow/${slug}.svg`} alt={`Flowchart: ${label}`} className="w-full max-w-3xl mx-auto rounded-lg border border-slate-200 bg-white p-2" data-testid="defects-flowchart-image" />
        </div>
      )}
    </div>
  );
};
